import styled from 'styled-components';

interface ArtworkBulkActionsProps {
  selectedCount: number;
  onTagSelected: () => void;
  onDeleteSelected: () => void;
}

const BulkActionsBar = styled.div<{ $show: boolean }>`
  position: fixed;
  bottom: ${({ $show }) => $show ? '20px' : '-100px'};
  left: 50%;
  transform: translateX(-50%);
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing.md} ${({ theme }) => theme.spacing.xl};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  box-shadow: ${({ theme }) => theme.shadows.xl};
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  align-items: center;
  transition: all ${({ theme }) => theme.transitions.normal};
  z-index: 1000;
`;

const BulkActionButton = styled.button<{ $variant?: 'danger' }>`
  background: ${({ $variant, theme }) => $variant === 'danger' ? theme.colors.error : theme.colors.white};
  color: ${({ $variant, theme }) => $variant === 'danger' ? theme.colors.white : theme.colors.primary};
  border: none;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ $variant, theme }) => $variant === 'danger' ? `${theme.colors.error}dd` : theme.colors.gray.light};
  }
`;

const SelectionInfo = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`;

export function ArtworkBulkActions({
  selectedCount,
  onTagSelected,
  onDeleteSelected,
}: ArtworkBulkActionsProps) {
  return (
    <BulkActionsBar $show={selectedCount > 0}>
      <SelectionInfo>
        {selectedCount} artwork{selectedCount !== 1 ? 's' : ''} selected
      </SelectionInfo>

      <BulkActionButton onClick={onTagSelected}>
        🏷️ Tag Selected
      </BulkActionButton>

      <BulkActionButton $variant="danger" onClick={onDeleteSelected}>
        🗑️ Delete Selected
      </BulkActionButton>
    </BulkActionsBar>
  );
}

export type { ArtworkBulkActionsProps };
